<script setup lang="ts">
import blackberrySrc from '@/assets/quiz/value-props/blackberry.svg';
import boldAndPepperySrc from '@/assets/quiz/value-props/bold-and-peppery.svg';
import chocolatyAndRichSrc from '@/assets/quiz/value-props/chocolaty-and-rich.svg';
import circleSrc from '@/assets/quiz/value-props/circle.svg';
import crunchyAndNuttySrc from '@/assets/quiz/value-props/crunchy-and-nutty.svg';
import cupSrc from '@/assets/quiz/value-props/cup.svg';
import diamondSrc from '@/assets/quiz/value-props/diamond.svg';
import fruityAndZestySrc from '@/assets/quiz/value-props/fruity-and-zesty.svg';
import heartSrc from '@/assets/quiz/value-props/heart.svg';
import savoryAndSaltySrc from '@/assets/quiz/value-props/savory-and-salty.svg';
import sunSrc from '@/assets/quiz/value-props/sun.svg';
import sweetAndCrunchySrc from '@/assets/quiz/value-props/sweet-and-crunchy.svg';
import sweetAndGummySrc from '@/assets/quiz/value-props/sweet-and-gummy.svg';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import { QuizAnswer } from '@/data/quiz/onsiteOffer';

defineProps<{
  lastSelectedAnswer?: QuizAnswer;
}>();

const imageSourceMap: Record<QuizAnswer['id'], string> = {
  ftb25_v3_q2_bored: sunSrc,
  ftb25_v3_q2_gift: blackberrySrc,
  'ftb25_v3_q2_healthier-options': heartSrc,
  'ftb25_v3_q2_party-or-event': diamondSrc,
  'ftb25_v3_q2_something-indulgent': circleSrc,
  'ftb25_v3_q2_work-or-school': cupSrc,
  'ftb25_v3_q3_bold-peppery': boldAndPepperySrc,
  'ftb25_v3_q3_chocolaty-rich': chocolatyAndRichSrc,
  'ftb25_v3_q3_crunchy-nutty': crunchyAndNuttySrc,
  'ftb25_v3_q3_fruity-zesty': fruityAndZestySrc,
  'ftb25_v3_q3_savory-salty': savoryAndSaltySrc,
  'ftb25_v3_q3_sweet-crunchy': sweetAndCrunchySrc,
  'ftb25_v3_q3_sweet-gummy': sweetAndGummySrc,
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <div v-if="lastSelectedAnswer?.valueProp" class="flex col-span-2 gap-2 p-3">
      <img :src="imageSourceMap[lastSelectedAnswer.id]" class="flex-shrink-0 w-12 h-12" alt="" />
      <BaseBodyText>{{ lastSelectedAnswer.valueProp }}</BaseBodyText>
    </div>
  </transition>
</template>
